import { ReactElement, useEffect, useState } from 'react';
import appServices from '../../services/app-services/appServices';

interface Props {
  groupId: number;
  alt?: string;
  style?: any;
  onImageLoaded?: (blob: Blob) => void;
  altImg?: any;
}

function GroupIcon({ groupId, alt, style, onImageLoaded, altImg }: Props): ReactElement {
  const [imageUrl, setImageUrl] = useState<string>(altImg ? altImg : '');

  useEffect(() => {
    if (!groupId) {
      return
    }
    appServices.getGroupIcon(groupId).then(blob => {
      setImageUrl(URL.createObjectURL(blob));
      if (onImageLoaded) {
        onImageLoaded(blob);
      }
    }).catch(e => {
      //TODO 画像を取得できない場合に代わりに表示したい画像はあるか？
    })
  }, [groupId]);

  return (
    <>
      {imageUrl ? <img src={imageUrl} alt={alt} style={style} /> : <span style={style}></span>}
    </>
  );
};

export default GroupIcon;
